import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const UrbaniaIcon = ({ color, className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="59.1"
        height="20.4"
        viewBox="0 0 59.1 20.4"
        className={className}
    >
        <path
            fill={color}
            d="M21.7 9.8c0-.1.8-.3 1.3-.9.4-.5.6-1.1.6-2V4.4c0-1.2-.3-2.4-1.1-3.2C21.6.4 20.2 0 19 0h-2.9c-.3 0-.5 0-.7.1-.2.1-.2.4-.2.8v18.4c0 .6 0 .7.2.9.1.2.5.1.9.1h2.8c1.1 0 2.5-.3 3.4-1.3 1-1 1.2-2 1.2-3.1v-3.4c0-.8-.1-1.3-.5-1.8-.6-.7-1.5-.8-1.5-.9zm-3.4-6.2c0-.2 0-.3.1-.4.1-.1.3-.1.7-.1.5 0 .7.1.9.3.4.4.4 1 .4 1.6v2c0 .3 0 .7-.4 1.1-.3.3-.7.4-1 .4-.2 0-.4 0-.5-.1-.1-.1-.1-.3-.1-.6-.1-1.1-.1-2.9-.1-4.2zm2.3 12c0 .5 0 .9-.4 1.3-.3.3-.8.4-1 .4h-.6c-.2 0-.2-.3-.2-.6v-4.8c0-.5.1-.6 1-.6.8 0 1.2.8 1.2 1.8v2.5zM11.7 9.9c0-.1.9-.3 1.4-1 .4-.5.5-1.1.5-1.9V4.5c0-1.2-.3-2.4-1.2-3.2C11.6.4 10.3 0 9.1 0H6.2c-.4 0-.6 0-.8.2-.1.1-.1.4-.1.7v14.7c0 .8-.2 1.6-1.1 1.6-1 0-1.1-.8-1.1-1.6V.4c0-.3-.3-.4-1.5-.4C.2 0 0 .1 0 .5v15.8c0 2.1 1.6 4 4.2 4 2.7 0 4.2-1.7 4.2-4.1v-4.8c.1-.2.3-.1 1.1-.1.7 0 1.1.8 1.1 1.8v6.7c0 .5.1.5 1.5.5s1.6 0 1.6-.5v-7.3c0-.8-.1-1.3-.5-1.8-.5-.7-1.5-.7-1.5-.8zM10.6 7c0 .3 0 .7-.4 1.1-.3.3-.8.4-1 .4-.2 0-.4 0-.5-.1-.3 0-.3-.2-.3-.5V3.6c0-.1 0-.3.1-.4.1-.1.3-.1.6-.1.7 0 .8.1 1 .3.4.4.4 1 .4 1.6.1.7.1 1.3.1 2zM31.4 20.4c-.8 0-1.4.1-1.5-.3-.2-1.6-.3-2.7-.6-4.3 0-.3-.4-.2-.8-.2-.6 0-.8-.1-.9.2-.2 1.6-.3 2.7-.4 4.4 0 .3-.7.3-1.6.3-.4 0-1.5 0-1.4-.3C25.3 12.6 26 7.5 27 .5c.1-.5.9-.5 1.5-.5.7 0 1.5 0 1.6.5 1.1 7.5 1.7 12 2.9 19.6.1.3-.8.3-1.6.3zm-2.6-13c0-.1-.1-.8-.3-.8-.1 0-.2.7-.2.8-.1 2.3-.3 3.7-.4 5.6 0 .2.1.2.6.2.4 0 .7.1.6-.2-.1-2.1-.2-3.3-.3-5.6zM42 20.4c-.8 0-1.1-.1-1.3-.8-1-3.4-1.3-4.9-2.3-8.6-.2-.6-.4-1.7-.6-1.7-.2 0-.2.6-.2 1v9.6c0 .5-.1.5-1.6.5s-1.5-.1-1.5-.5V.4c0-.4.1-.4 1.4-.4 1.3 0 1.4.1 1.6.9.6 2.4 1.5 5.5 2.4 8.6.1.3.2.8.3.8.2 0 .2-.6.2-.9V.5c0-.4.1-.5 1.6-.5s1.5 0 1.5.5v19c0 .8 0 .9-1.5.9zM47.2 20.4c-1.4 0-1.5 0-1.5-.4V.6c0-.4.1-.5 1.5-.5 1.5 0 1.6 0 1.6.5V20c0 .3 0 .4-1.6.4zM57.5 20.4c-.8 0-1.4.1-1.5-.3-.2-1.6-.3-2.7-.6-4.3 0-.3-.4-.2-.8-.2-.6 0-.8-.1-.9.2-.2 1.6-.3 2.7-.4 4.4 0 .3-.7.3-1.6.3-.4 0-1.5 0-1.4-.3 1.1-7.6 1.8-12.7 2.8-19.7 0-.5.9-.5 1.5-.5.7 0 1.5 0 1.6.5 1.1 7.5 1.7 12 2.9 19.6.1.3-.8.3-1.6.3zm-2.6-13c0-.1-.1-.8-.3-.8-.1 0-.2.7-.2.8-.1 2.3-.3 3.7-.4 5.6 0 .2.1.2.6.2.4 0 .7.1.6-.2-.1-2.1-.2-3.3-.3-5.6z"
        />
    </svg>
);

UrbaniaIcon.propTypes = propTypes;
UrbaniaIcon.defaultProps = defaultProps;

export default UrbaniaIcon;
